import { Button, Space, Table, Form, Input, Select } from "antd";
import Axios from "middleware/axiosInstance";
import { Link, useParams } from "react-router-dom";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import Loading from "layouts/Loading/Loading";
import { convertToMiladi } from "utils/dateCoverter";
import { useState } from "react";
import { Row, Col, Checkbox } from "antd";
import "antd/dist/antd.css";
import useAxios from "middleware/useAxios";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Icon from "react-multi-date-picker/components/icon";

const { Option } = Select;

const WarehouseReportInSummaryMode = () => {
  const serverDomain = process.env.REACT_APP_Server_Domain;

  const [justIsTrustDocs, setJustIsTrustDocs] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [data, setData] = useState(null);
  const [customizedData, setCustomizedData] = useState(null);
  const [
    valuesAndParamsOfFilteredItemsByUser,
    setValuesAndParamsOfFilteredItemsByUser,
  ] = useState({
    anbar_id: "",
    commodity_id: "",
    people_id: "",
    from_date: "",
    to_date: "",
    is_trust: 0,
  });

  const [form] = Form.useForm();

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const [startAndEndOfDateForFilter, setStartAndEndOfDateForFilter] =
    useState(null);

  const [allWarehouse] = useAxios({
    method: "get",
    url: "/anbar",
  });

  const changeDateAndTimeOfDocHandler = (e) => {
    console.log(e);
    const temp = [];
    if (e[0]) {
      const startDateInShamsi = `${e[0].year}-${e[0].month.number}-${e[0].day}`;
      const startDateInMiladi = convertToMiladi(startDateInShamsi);
      temp.push({ shamsi: startDateInShamsi, miladi: startDateInMiladi });
    }

    if (e[1]) {
      const endDateInShamsi = `${e[1].year}-${e[1].month.number}-${e[1].day}`;
      const endDateInMiladi = convertToMiladi(endDateInShamsi);
      temp.push({ shamsi: endDateInShamsi, miladi: endDateInMiladi });
    }
    console.log(temp);
    setStartAndEndOfDateForFilter(temp);
  };

  const handleFilterFormValuesSubmit = (e) => {
    console.log(e);
    if (startAndEndOfDateForFilter) {
      if (startAndEndOfDateForFilter[0]) {
        e.from_date = startAndEndOfDateForFilter[0].miladi;
        console.log(e.from_date);
      }
      if (startAndEndOfDateForFilter[1]) {
        e.to_date = startAndEndOfDateForFilter[1].miladi;
      }
    }
    if (justIsTrustDocs === false || e.people_id === "") {
      delete e.people_id;
    }
    setValuesAndParamsOfFilteredItemsByUser(e);
    setIsLoading(true);
    Axios.post("date_report", e)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const downloadExcelFileOfFilteredFields = () => {
    window.location.href = `${serverDomain}/api/date_report_download?anbar_id=${
      valuesAndParamsOfFilteredItemsByUser.anbar_id || ""
    }&from_date=${
      valuesAndParamsOfFilteredItemsByUser.from_date
        // ? convertToMiladi(valuesAndParamsOfFilteredItemsByUser.from_date)
        ? valuesAndParamsOfFilteredItemsByUser.from_date
        : ""
    }&to_date=${
      valuesAndParamsOfFilteredItemsByUser.to_date
        // ? convertToMiladi(valuesAndParamsOfFilteredItemsByUser.to_date)
        ? valuesAndParamsOfFilteredItemsByUser.to_date
        : ""
    }&is_trust=${justIsTrustDocs ? "1" : "0"}${
      valuesAndParamsOfFilteredItemsByUser.people_id
        ? `&people_id=${valuesAndParamsOfFilteredItemsByUser.people_id}`
        : ""
    }`;
  };
  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const [allPeople] = useAxios({
    method: "get",
    url: "/people",
  });

  const columns = [
    {
      title: "شناسه کالا",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      sortOrder: sortedInfo.columnKey === "id" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "نام کالا",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0),
      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
    },
    {
      title: "تعداد ورودی",
      dataIndex: "import",
      key: "import",

      sorter: (a, b) => a.import - b.import,

      sortOrder: sortedInfo.columnKey === "import" ? sortedInfo.order : null,
    },
    {
      title: "تعداد خروجی",
      dataIndex: "export",
      key: "export",
      sorter: (a, b) => a.export - b.export,

      sortOrder: sortedInfo.columnKey === "export" ? sortedInfo.order : null,
    },
    {
      title: "تجمیع",
      dataIndex: "count",
      key: "count",
      sorter: (a, b) => a.count - b.count,
      sortOrder: sortedInfo.columnKey === "count" ? sortedInfo.order : null,
    },
  ];

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">گزارش تجمیعی ورودی و خروجی ها</h5>

        <Form
          layout="vertical"
          form={form}
          autoComplete="off"
          scrollToFirstError
          labelCol={{ xs: 24 }}
          onFinish={handleFilterFormValuesSubmit}
        >
          <Row gutter={8}>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label={"انبار"} name="anbar_id">
                <Select
                  loading={!allWarehouse?.[0]}
                  fieldNames="anbar_id"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="anbar_id"
                >
                  {allWarehouse?.map((wareHouse) => {
                    return (
                      <Option key={wareHouse.id} value={wareHouse.id}>
                        {wareHouse.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="تاریخ"
                name="date"
                rules={[
                  {
                    required: false,
                    message: "انتخاب بازه زمانی الزامی می باشد",
                  },
                  () => ({
                    validator(_, value) {
                      if (
                        startAndEndOfDateForFilter?.[0] &&
                        startAndEndOfDateForFilter?.[1] === undefined
                      ) {
                        return Promise.reject("تاریخ پایان اجباری");
                      } else return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input
                  disabled
                  placeholder={
                    startAndEndOfDateForFilter?.[0] &&
                    startAndEndOfDateForFilter?.[1]
                      ? ` ${startAndEndOfDateForFilter[0]?.shamsi} - ${startAndEndOfDateForFilter[1]?.shamsi} `
                      : "انتخاب تاریخ"
                  }
                  addonBefore={
                    <DatePicker
                      // value={newWarehouseEntryDocument.date}
                      onChange={(e) => changeDateAndTimeOfDocHandler(e)}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-left"
                      range
                      render={
                        <Icon
                          style={{
                            color: "gray",
                            width: "23px",
                          }}
                        />
                      }
                    />
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={4} xl={3}>
              <Form.Item name="is_trust" valuePropName="checked">
                <Checkbox
                  onChange={() => {
                    setJustIsTrustDocs(!justIsTrustDocs);
                    form.setFieldsValue({
                      people_id: "",
                    });
                  }}
                >
                  فقط اسناد امانی
                </Checkbox>
              </Form.Item>
            </Col>
            {justIsTrustDocs && (
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item label="شخص" name="people_id">
                  <Select
                    loading={!allPeople?.[0]}
                    showSearch
                    style={{
                      width: 200,
                    }}
                    fieldNames="people_id"
                    placeholder="انتخاب فرمایید"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    id="people_id"
                  >
                    {allPeople?.map((people) => {
                      return (
                        <Option key={people.id} value={people.id}>
                          {`${people.name} ${people.family}`}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            )}
          </Row>
          <Row gutter={8}>
            <Space>
              <Form.Item>
                <Button htmlType="submit" type="primary">
                  جستجو
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType="button"
                  type="primary"
                  onClick={() => {
                    form.resetFields();
                    setStartAndEndOfDateForFilter(null);
                    setValuesAndParamsOfFilteredItemsByUser({
                      anbar_id: "",
                      from_date: "",
                      to_date: "",
                    });
                  }}
                >
                  حذف فیلترها
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType="button"
                  type="primary"
                  onClick={downloadExcelFileOfFilteredFields}
                >
                  دانلود فایل Excel
                </Button>
              </Form.Item>
            </Space>
          </Row>
        </Form>

        {isLoading ? (
          <Loading />
        ) : data ? (
          <Table
            pagination={false}
            columns={columns}
            dataSource={data}
            rowKey={data.id}
            onChange={handleChange}
          />
        ) : null}
      </div>
    </div>
  );
};
export default WarehouseReportInSummaryMode;
